import type {
  ExportDate,
  ExportFormat,
  ExportMode,
  ExportOption,
  ExportType,
} from '@/modules/exports'
export type TypeChart = 'day' | 'week' | 'month'

export type ReportDataItem = [string, string]

/* Forms */

export interface ExportActivitiesForm {
  exportType: ExportType
  exportOption: ExportOption
  exportFormat: ExportFormat
  weekly: boolean
  vehicle: string | null
  modeType: ExportMode
  date?: Date
  dateEnd?: Date
  dateType?: ExportDate
  detailed?: boolean
}

export interface ActivitiesForm {
  exportType: ExportType
  exportOption: ExportOption
  exportFormat: ExportFormat
  useDateRange: boolean
  month: Date
  dateStart: Date
  dateEnd: Date
  user: string | null
  users: string[]
  orderBy: UserOrderBy
  includeAbsences?: boolean
  weekly: boolean
}

/* Other */

export interface DayReport {
  [key: string]: Date | string | boolean | null | undefined

  sortingDate: Date
  regNr: string | null

  startTime: string | null
  endTime: string | null
  dayStartLocation: string | null
  dayEndLocation: string | null

  timeDriving: string | null
  timeOvertime: string | null
  timeAvailability: string | null
  timeRest: string | null
  timePause: string | null
  timeOtherWork: string | null
  dataStatus: boolean | null
  approved?: boolean | null
}

export interface DaySummation {
  work: number
  rest: number
  driving: number
}

export interface WeekSummation {
  [key: string]: string | null

  timeDriving: string | null
  timeOvertime: string | null
  timeAvailability: string | null
  timeRest: string | null
  timePause: string | null
  timePaidRest: string | null
  timeOtherWork: string | null
  diet: string | null
  salaryDay: string | null
}

export type VehicleColorDictionary = {
  [key: string]: string
}

export enum UserOrderBy {
  FAMILY_NAME = 'last_name',
  USER_TYPES = 'user_types',
  INTERNAL_NUMBER = 'internal_number',
}

export enum AddonType {
  FIXED = 'FIXED',
  OVERRIDE = 'OVERRIDE',
  TIME = 'TIME',
}
